import React, { useEffect, useState } from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getAllTicket } from '../api/ticketApi';
import DOMPurify from 'dompurify';
// import CryptoJS from 'crypto-js';

const ListTickets = () => {
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [titleFilter, setTitleFilter] = useState('');
  const [priorityFilter, setPriorityFilter] = useState('');
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [ticketsToShow, setTicketsToShow] = useState(3);
  const [showFilter, setShowFilter] = useState(false);

  console.log(filteredTickets);
  useEffect(() => {
    const workspace_id = sessionStorage.getItem('login_workspaces_id');
    const fetchTickets = async () => {
      try {
        setLoading(true);
        const data = await getAllTicket(workspace_id);
        setTickets(data.results);
        setFilteredTickets(data.results);
      } catch (err) {
        setError('Failed to fetch tickets.');
      } finally {
        setLoading(false);
      }
    };

    fetchTickets();
  }, []);
  useEffect(() => {
    const filtered = tickets.filter((ticket) => {
      const matchTitle = titleFilter
        ? ticket.title.toLowerCase().includes(titleFilter.toLowerCase())
        : true;

      const matchPriority = priorityFilter
        ? ticket.status_display.toLowerCase() === priorityFilter.toLowerCase()
        : true;

      return matchTitle && matchPriority;
    });

    setFilteredTickets(filtered);
  }, [titleFilter, priorityFilter, tickets]);

  useEffect(() => {
    const updateTicketsToShow = () => {
      const width = window.innerWidth;
      if (width >= 1024) {
        setTicketsToShow(6);
      } else {
        setTicketsToShow(3);
      }
    };

    updateTicketsToShow();

    window.addEventListener('resize', updateTicketsToShow);
    return () => window.removeEventListener('resize', updateTicketsToShow);
  }, []);

  const onButtonClick = async (ticketId) => {
    navigate(`/ticketdetails/${ticketId}`);
  };
  console.log(tickets);
  const handleSearch = () => {
    const filtered = tickets.filter((ticket) => {
      const matchTitle = titleFilter
        ? ticket.title.toLowerCase().includes(titleFilter.toLowerCase())
        : true;
      const matchPriority = priorityFilter
        ? ticket.status_display
            .toLowerCase()
            .includes(priorityFilter.toLowerCase())
        : true;
      return matchTitle && matchPriority;
    });
    console.log(filtered);
    setFilteredTickets(filtered);
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Open':
        return { dot: 'bg-[#22c55e]', text: 'text-[#16a34a]' };
      case 'Closed':
        return { dot: 'bg-[#ef4444]', text: 'text-[#dc2626]' };
      default:
        return { dot: 'bg-gray-400', text: 'text-gray-600' };
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f8fafc] via-[#eff6ff4d] to-[#eef2ff66] p-6">
      <h1 className="text-center text-[#0B214E] text-2xl font-bold mb-6">
        Tickets
      </h1>

      <div className="bg-white rounded-xl shadow-sm w-full max-w-full mb-4">
        <div className="relative flex items-center gap-3 px-5 py-4 border-b border-[#EEEDEB]">
          <div className="flex items-center flex-1 bg-[#F5F7FA] border border-[#E2E8F0] rounded-lg px-3 py-2 gap-2">
            <svg
              className="w-4 h-4 text-gray-400 shrink-0"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <circle cx="11" cy="11" r="8" />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35"
              />
            </svg>
            <input
              type="text"
              value={titleFilter}
              onChange={(e) => setTitleFilter(e.target.value)}
              placeholder="Search Query"
              className="bg-transparent text-sm text-gray-700 outline-none w-full placeholder:text-[#A0AEC0]"
            />
          </div>

          <button
            onClick={handleSearch}
            className="flex items-center justify-center w-9 h-9 border border-[#E2E8F0] rounded-lg bg-white hover:bg-gray-50"
            title="Filter"
          >
            <button onClick={() => setShowFilter(!showFilter)}></button>
            <button
              onClick={() => setShowFilter(!showFilter)}
              className="flex items-center justify-center w-9 h-9 border border-[#E2E8F0] rounded-lg bg-white hover:bg-gray-50"
            >
              <svg
                className="w-4 h-4 text-gray-500"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 4h18M7 8h10M11 12h2M9 16h6"
                />
              </svg>
            </button>

            {showFilter && (
              <div className="absolute top-14 right-32 z-20">
                <div className="bg-white rounded-2xl shadow-lg p-2 w-56 border border-gray-100">
                  {[
                    { label: 'Open', color: '#22c55e' },
                    { label: 'Closed', color: '#1e293b' },
                  ].map((item, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        setPriorityFilter(item.label);
                        setShowFilter(false);
                      }}
                      className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 rounded-lg cursor-pointer transition"
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = '#EFF6FF')
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = 'transparent')
                      }
                    >
                      <span
                        style={{ backgroundColor: item.color }}
                        className="w-3 h-3 rounded-full flex-shrink-0"
                      />
                      {item.label}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </button>

          <button
            onClick={() => navigate('/createticket')}
            className="bg-[#E8821A] hover:bg-[#d07215] text-white px-5 py-2 font-semibold rounded-lg text-sm flex items-center gap-1.5 whitespace-nowrap"
          >
            <span className="text-lg leading-none">+</span> Create Query
          </button>
        </div>
        <div className="relative">
          {loading && (
            <div
              className="absolute inset-0 z-30 flex items-center justify-center bg-white/90 rounded-xl"
              style={{ pointerEvents: 'auto' }}
            >
              <div className="flex flex-col items-center gap-3">
                <Spinner animation="border" role="status" />
                <span className="text-base text-[#0B214E] font-semibold mt-2">
                  Loading...
                </span>
              </div>
            </div>
          )}

          {error && (
            <Alert variant="danger" className="text-center mx-5 mt-3">
              {error}
            </Alert>
          )}

          {loading ? (
            <div className="flex flex-col gap-4 py-10 px-6 animate-pulse">
              {[...Array(3)].map((_, i) => (
                <div
                  key={i}
                  className="flex justify-between items-center border-b pb-4 last:border-b-0"
                >
                  <div className="flex items-start gap-4 w-full">
                    <div className="w-10 h-10 rounded-full bg-gray-300" />
                    <div className="flex flex-col gap-2 w-full">
                      <div className="h-4 w-1/4 bg-gray-300 rounded" />
                      <div className="h-3 w-3/4 bg-gray-200 rounded" />
                      <div className="h-2 w-1/2 bg-gray-200 rounded" />
                    </div>
                  </div>
                  <div className="w-10 h-10 bg-gray-300 rounded-lg" />
                </div>
              ))}
            </div>
          ) : filteredTickets.length === 0 ? (
            <div className="flex flex-col items-center justify-center px-6 py-10 text-center text-gray-600">
              <img
                src="/icons/list-ticket-dark.svg"
                alt="No Tickets"
                className="w-24 h-24 mb-4"
              />
              <p className="text-lg font-semibold">No Tickets Found</p>
            </div>
          ) : (
            filteredTickets.slice(0, ticketsToShow).map((ticket, index) => {
              const statusStyle = getStatusStyle(ticket.status_display);
              return (
                <div
                  key={ticket.id || index}
                  className="flex items-center justify-between px-5 py-4 border-b border-[#F0F4FA] last:border-b-0 hover:bg-[#FAFBFD] transition-colors"
                >
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-full bg-[#0B214E] text-white flex items-center justify-center font-bold text-base shrink-0">
                      {ticket.title?.charAt(0).toUpperCase() || 'T'}
                    </div>

                    <div className="flex flex-col gap-0.5">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-sm font-semibold text-[#1A202C]">
                          {ticket?.title}
                        </span>
                        {ticket?.createdDate && (
                          <span className="text-xs text-[#A0AEC0]">
                            {ticket.createdDate}
                          </span>
                        )}
                        <span
                          className={`flex items-center gap-1 text-xs font-medium ${statusStyle.text}`}
                        >
                          <span
                            className={`w-2 h-2 rounded-full ${statusStyle.dot}`}
                          />
                          {ticket.status_display}
                        </span>
                        {ticket.status_display === 'Closed' && (
                          <img
                            src="/icons/pin-icon.svg"
                            alt="Pin"
                            className="w-4 h-4"
                          />
                        )}
                      </div>

                      <div className="text-sm text-[#4A5568]">
                        <div className="flex flex-row">
                          <span
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                (ticket.description || '').length > 300
                                  ? ticket.description.substring(0, 300) + '...'
                                  : ticket.description,
                                {
                                  ALLOWED_TAGS: [
                                    'b',
                                    'i',
                                    'u',
                                    'a',
                                    'br',
                                    'strong',
                                    'em',
                                    'p',
                                    'ul',
                                    'ol',
                                    'li',
                                  ],
                                  ALLOWED_ATTR: ['href', 'target', 'rel'],
                                },
                              ),
                            }}
                          />
                        </div>
                      </div>

                      {ticket.subtitle && (
                        <p className="text-xs text-[#718096]">
                          {ticket.subtitle}
                        </p>
                      )}
                    </div>
                  </div>
                  <button
                    onClick={() => onButtonClick(ticket.id)}
                    className="flex items-center justify-center w-9 h-9 border border-[#E2E8F0] rounded-lg bg-white hover:bg-[#F5F7FA] text-[#4A5568] shrink-0 ml-4"
                    title="View"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"
                      />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </button>
                </div>
              );
            })
          )}
        </div>

        {!loading && filteredTickets.length > 0 && (
          <div className="flex justify-end px-5 py-3 border-t border-[#F0F4FA]">
            <button
              onClick={() => navigate('/alltickets')}
              className="text-[#2563eb] font-semibold text-sm hover:underline"
            >
              View All
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ListTickets;
